//TODO : 將依賴user改成state.jwt
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import './App.css';
import { state } from './assets/vender/funcodeDecoder';

function App() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const user = useSelector(state => state.user.value)

  useEffect(() => {
    // 檢查是否有保存的JWT
    const savedJwt = localStorage.getItem('_fa_jwt');
    
    if (!savedJwt) {
      // 如果沒有JWT，清除所有相關存儲
      localStorage.removeItem('_fa_jwt');
      localStorage.removeItem('_fa_btc');
      localStorage.removeItem('_fa_did');
      localStorage.removeItem('_fa_lit');
      localStorage.removeItem('_fa_rem');
      
      // 導航到登錄頁
      navigate('/login');
    } else {
      // 如果有JWT且有用戶名，導航到首頁
      if (user?.username) {
        navigate('/home');
      }
    }
  }, [navigate, dispatch, user]);
  
  return (
    <Outlet />
  );
}

export default App;
